import { useAuth } from "./useAuth";
import { useStore } from "../state/store";

/**
 * Unified guest / view-only detection for launch lockdown.
 * Guests (no signed-in session) may browse buyer/seller structure but cannot enter or modify data.
 * Signed-in buyers, sellers, agents, brokers, and admin/dev retain full edit rights.
 */
export function useGuestMode() {
  const { session } = useAuth();
  const { dispatch } = useStore();

  const isSignedIn = Boolean(session && (session.userId || session.role));
  /** View-only when there is no authenticated session. */
  const isViewOnly = !isSignedIn;
  const isGuest = isViewOnly;

  function openGuestLock() {
    dispatch({ type: "OPEN_MODAL", payload: "guestLock" });
  }

  function guardInteract(event) {
    if (!isViewOnly) return false;

    const target = event?.target;
    if (!(target instanceof Element)) return false;

    /* Navigation and chrome stay fully enabled */
    if (
      target.closest(
        [
          "a[href]",
          ".wizard-actions",
          ".buyer-nav",
          ".seller-nav",
          ".journey-mini-nav",
          ".journey-sidebar__toggle",
          ".journey-sidebar__chrome",
          ".frame-zoom",
          ".nav-link",
          ".site-header",
          ".site-footer",
          ".modal-backdrop",
          ".modal-container",
          ".desk-theme-toggle",
        ].join(", ")
      )
    ) {
      return false;
    }

    event.preventDefault();
    event.stopPropagation();
    openGuestLock();
    return true;
  }

  return {
    isGuest,
    isViewOnly,
    canEdit: !isViewOnly,
    canPersist: !isViewOnly,
    openGuestLock,
    guardInteract,
  };
}
